export function getFileNameValidationResult(file: Blob | string, validExtentions: string[]): boolean {
	const pattern = RegExp(`^.+\\.(${validExtentions.join("|")})$`);
	if (file instanceof File) {
		return pattern.test(file.name);
	}
	if (typeof file === "string") {
		return pattern.test(file);
	}
	return false;
}

export const getFileExtention = (fileName: string) => {
	return fileName?.split(".")?.pop()?.toLowerCase();
};
